import {
    apiRequest,
    pengalamanKerjaCreate
} from "../../../../../services/adapters/kepegawaian/pengalamanKerjaService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", pengalamanKerjaCreate, {
            body: query
        }, true)
    }
}

export default CreateRepository